<script lang="ts">
  import { get } from 'svelte/store'
  import { isLoggingInProcessStore, fn, pageStore } from '@packages/stores'
  import { configStore, forcedPage } from '@src/stores/config'
  import { onDestroy } from 'svelte'
  import { Login } from '@packages/ui'
  import { AUTH_PROVIDERS } from '@packages/utils/enums'

  let config = get(configStore)
  let isLoading: boolean = false

  const { login, close, toastAlert } = get(fn)

  const handleLogin = async ({ provider }: { provider: AUTH_PROVIDERS }) => {
    try {
      isLoading = true
      await login(provider)
      isLoading = false
      if (!$forcedPage && !$pageStore) close()
    } catch (err) {
      toastAlert('Error during login process', 'failure')
      isLoading = false
    }
  }

  const authTitle = config.content?.auth?.title ?? 'Let’s get started'
  const authDescription = config.content?.auth?.description ?? 'Confirm your account to connect.'
  const loginIndicatorSub = isLoggingInProcessStore.subscribe((val) => (isLoading = val))
  onDestroy(loginIndicatorSub)
</script>

<Login
  options={{
    isLoading,
    authTitle,
    authDescription,
    authOptions: {
      loginMethods: [
        {
          provider: AUTH_PROVIDERS.OAUTH,
          text: "Login Using Credenza's System",
        },
      ],
      handleLogin,
    },
  }}
/>
